<template>
    <GChart
        type="PieChart"
        :data="chartData"
        :options="chartOptions"
    />
</template>

<script>
    export default {
        props: ['valores'],
        data() {
            return {
                chartOptions: {
                    height: 374,
                    chartArea:{width:'auto'},
                    pieHole: 0.4,
                    responsive: true
                }
            }
        },
        computed: {
            chartData(){
                var data = null;
                if(this.valores) {
                    data = [];
                    data.push(['Tipo', 'Total']);
                    data.push(['Online', this.valores.Online])
                    data.push(['Taquilla', this.valores.Taquilla])
                } else {
                    data = null;
                }

                return data;
            }
        }
    }
</script>